import { Button, Flex, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { useSaveCenterReportCriteriaComplete } from '@/module/ResearchCenter';

import { Id, useAppNotification } from '@feature/utils';

interface CriteriaHeaderButtonsProps {
  completed: boolean;
  onAdd: () => void;

  labId: Id;
  criteriaCode: string;
}

export function CriteriaHeaderButtons({ completed, onAdd, labId, criteriaCode }: CriteriaHeaderButtonsProps) {
  const notification = useAppNotification();
  const { t } = useTranslation();

  const completeMutation = useSaveCenterReportCriteriaComplete(labId, criteriaCode);

  const setStatus = (isComplete: boolean) => {
    completeMutation.mutate(isComplete, {
      onError: notification.error,
    });
  };
  return (
    <Flex
      justify="space-between"
      align="center"
      mb="15px"
    >
      <Button
        size="xs"
        onClick={onAdd}
        disabled={completed}
      >
        {t('button.add')}
      </Button>
      <Text
        ml="120px"
        size="sm"
        fw="500"
        fs="italic"
        c={completed ? 'green' : 'dimmed'}
      >
        {completed ? 'Marcat drept complet' : 'În derulare'}
      </Text>
      {!completed && (
        <Button
          size="xs"
          bg="green"
          disabled={completed}
          onClick={() => setStatus(true)}
        >
          {t('centerReport.markCompleted')}
        </Button>
      )}
      {completed && (
        <Button
          size="xs"
          bg="red"
          disabled={!completed}
          onClick={() => setStatus(false)}
        >
          {t('centerReport.markUnfinished')}
        </Button>
      )}
    </Flex>
  );
}
